import { Controller, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { DressingsListAliases, FragmentNames } from '../../../../../codegen/index';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../../constants/routes';
import BaseController from '../../../../BaseController';
import './dressings-list-controller.css';
import { DressingStatus, WoundsDressingTabType } from '../../../types/wounds-dressings-types';
import { WoundsDressingsTabListContext } from '../../../service/wounds-dressing-tab-list-service';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import { WoundsDressingContext } from '../../../wounds-dressing-service';
import InformationBarUtils from '../../../../../controllers/commons/header/information-bar-header-utils';

@Controller({ component: DressingsListAliases.LAYOUT_DRESSINGS_LIST, fragment: FragmentNames.DRESSINGS_LIST })
class DressingsListController extends BaseController {

  @Inject(DressingsListAliases.PANEL_ACTIONS_DRESSINGS_LIST)
  private panelGlobalActionsApi!: PanelAPI;

  @OnMount({target: DressingsListAliases.LAYOUT_DRESSINGS_LIST})
  handleMountLayout(): void {
    const allowInfo = InformationBarUtils.allowInfo && WoundsDressingContext.getAllowEdit();
    this.panelGlobalActionsApi.setVisible(allowInfo);
  }

  @OnClick({ target: DressingsListAliases.DECK_DRESSINGS })
  handleOnClick(event: ClickEvent): void {
    const { woundId } = this.historyService.getCurrentRouteParams();
    const dressingId = event.value.id;
    const status = event.value.status;
    const release = event.value.releaseDate;
    const allowInfo = InformationBarUtils.allowInfo && WoundsDressingContext.getAllowEdit();
    const dressingNotRelease = release == undefined && status == DressingStatus.PENDING_LIBERATION && allowInfo;
    dressingNotRelease ? this.openModalDressingCreateOrEdit(dressingId, woundId) : this.openModalDressingDetails(dressingId, woundId);
    WoundsDressingsTabListContext.currentTab = WoundsDressingTabType.DRESSINGS;
  }

  @OnClick({ target: DressingsListAliases.BUTTON_ADD_WOUNDS_DRESSINGS })
  handleOnClickButtonAddWoundsDressings(): void {
    const { woundId } = this.historyService.getCurrentRouteParams();
    this.openModalDressingCreateOrEdit(null, woundId);
  }

  private openModalDressingDetails(dressingId: number, woundId: number | unknown): void {
    const route = ApplicationRoute.DRESSINGS_VIEWER
    applicationContext.redirect(route, {
      dressingId,
      woundId
    });
  }

  private openModalDressingCreateOrEdit(dressingId: number | null, woundId: number | unknown): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(ApplicationRoute.DRESSINGS_CREATE, {
      encounterId,
      patientId,
      woundId
    },{
      searchParams: {
        dressingId
      }
    })
  }

}
export default DressingsListController;
